<div class="container-fluid">
    <app-pagetitle title="Orders" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>


    <div class="page-content-wrapper">

        <app-loader [loading]="loading"></app-loader>

        <div [class.loading-content]="loading">

            <div class="row">
                <div class="col-lg-12">
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <app-filter (filterChange)="filterChange($event)" [statusOptions]="statusOptions"
                                [isOrder]="true" searchBY="Plan, Currency, Notes & Payment Mode "></app-filter>

                            <p-table #dt [value]="orders" [lazy]="true" (onLazyLoad)="loadOrders($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Plan</th>
                                        <th>Currency</th>
                                        <th>Notes</th>
                                        <th>Payment Mode</th>
                                        <th>Status</th>
                                        <th>Created</th>
                                        <th>Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-order>
                                    <tr>
                                        <td>{{ order.planName }}</td>
                                        <td>{{ order.currency }}</td>
                                        <td>{{ order.notes || '-'}}</td>
                                        <td>{{ order.paymentMethod }}</td>
                                        <td>
                                            <div class="badge font-size-12" [ngClass]="{
                                            'bg-success-subtle text-success': order.status === 'Completed',
                                            'bg-warning-subtle text-warning': order.status === 'Pending',
                                            'bg-danger-subtle text-danger': order.status === 'Cancelled'
                                        }">{{ order.status }}</div>
                                        </td>
                                        <td>{{ order.createdAt | date:'short' }}</td>
                                        <td>
                                            <button class="btn btn-sm btn-outline-primary"
                                                (click)="getOrderDetail(order)">
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="9" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No orders found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        @if(showModal){
        <div class="modal fade show d-block">
            <div class="modal-dialog modal-md">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title">Order Details</h5>
                        <button class="btn-close" (click)="closeModal()"></button>
                    </div>

                    <div class="modal-body">
                        <form [formGroup]="editForm">

                            <div class="row g-3">

                                <!-- Plan Name -->
                                <div class="col-6">
                                    <div class="label fw-semibold text-muted small">Plan Name</div>
                                    <div class="value fw-bold fs-6">{{ orderdetail.planName }}</div>
                                </div>

                                <!-- Transaction ID -->
                                <div class="col-6">
                                    <div class="label fw-semibold text-muted small">Transaction ID</div>
                                    <div class="value font-monospace small">
                                        {{ orderdetail.transactionId }}
                                    </div>
                                </div>

                                <!-- Status -->
                                <div class="col-6">
                                    <div class="label fw-semibold text-muted small">Status</div>
                                    <span class="badge rounded-pill px-3 py-2" [ngClass]="{
            'bg-warning-subtle text-warning border border-warning':
              orderdetail.status === 'Pending',
            'bg-success-subtle text-success border border-success':
              orderdetail.status === 'Completed',
            'bg-danger-subtle text-danger border border-danger':
              orderdetail.status === 'Cancelled'
          }">
                                        {{ orderdetail.status }}
                                    </span>
                                </div>

                                <!-- Subscription -->
                                <div class="col-6">
                                    <div class="label fw-semibold text-muted small">Subscription</div>
                                    <div class="fw-semibold"
                                        [ngClass]="orderdetail.subscriptionActivated ? 'text-success' : 'text-danger'">
                                        {{ orderdetail.subscriptionActivated ? 'Activated' : 'Not Activated' }}
                                    </div>
                                </div>

                                <!-- Amount -->
                                <div class="col-6">
                                    <div class="label fw-semibold text-muted small">Amount</div>

                                    @if (orderdetail.planName === 'Enterprise' && orderdetail.status == 'Pending') {
                                    <input type="number" class="form-control" formControlName="amount">
                                    } @else {
                                    <div class="fw-bold">
                                        {{ orderdetail.currency }} {{ orderdetail.amount | number }}
                                    </div>
                                    }
                                </div>

                                <!-- Payment Method -->
                                <div class="col-6">
                                    <div class="label fw-semibold text-muted small">Payment Method</div>
                                    <div>{{ orderdetail.paymentMethod }}</div>
                                </div>

                                <!-- Documents -->
                                <div class="col-6">
                                    <div class="label fw-semibold text-muted small">Document Limit</div>

                                    @if (orderdetail.planName === 'Enterprise' && orderdetail.status == 'Pending') {
                                    <input type="number" class="form-control" formControlName="documents">
                                    } @else {
                                    <div>{{ orderdetail.documents || '-' }}</div>
                                    }
                                </div>

                                <!-- Users -->
                                <div class="col-6">
                                    <div class="label fw-semibold text-muted small">User Limit</div>

                                    @if (orderdetail.planName === 'Enterprise' && orderdetail.status == 'Pending') {
                                    <input type="number" class="form-control" formControlName="users">
                                    } @else {
                                    <div>{{ orderdetail.users || '-'}}</div>
                                    }
                                </div>

                                <!-- Created Date -->
                                <div class="col-6">
                                    <div class="label fw-semibold text-muted small">Created At</div>
                                    <div>
                                        {{ orderdetail.createdAt | date: 'dd MMM yyyy, hh:mm a' }}
                                    </div>
                                </div>

                                <!-- Plan Expiry Date -->
                                <div class="col-6">
                                    <div class="label fw-semibold text-muted small">Plan Expiry Date</div>
                                    @if (orderdetail.planName === 'Enterprise' && orderdetail.status == 'Pending') {
                                    <input type="date" class="form-control" formControlName="endDate">
                                    } @else{
                                    {{ orderdetail.endDate | date: 'dd MMM yyyy, hh:mm a' }}
                                    }
                                </div>

                                <!-- Notes -->
                                <div class="col-12">
                                    <div class="label fw-semibold text-muted small">Notes</div>
                                    <div class="border rounded p-2 bg-light">
                                        {{ orderdetail.notes || '-' }}
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>

                    <div class="modal-footer d-flex justify-content-between">

                        <button class="btn btn-outline-danger" (click)="updateOrderStatus(orderdetail,'Cancelled')"
                            [disabled]="orderdetail.status !== 'Pending'">
                            Cancel Order
                        </button>

                        <button class="btn btn-primary" (click)="updateOrderStatus(orderdetail,'Completed')"
                            [disabled]="orderdetail.status !== 'Pending'">
                            Mark as Completed
                        </button>

                    </div>

                </div>
            </div>
        </div>

        }

        @if(showModal){
        <div class="modal-backdrop fade show"></div>
        }
    </div>
</div>